import React from 'react'
import { Link, useNavigate } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';

import img3 from '../toronto1.jpg'
import img4 from '../toronto2.jpg'

function SliderNew() {
    const navigate = useNavigate();
    navigate("users");
    return (
        <>
            <div>
                <Carousel>
                    <Carousel.Item>
                        <img style={{ height: '100vh', maxHeight: "500px"}}
                            className="d-block w-100"
                            src={img4}
                            alt="First slide"
                        />
                        <Carousel.Caption>
                            <h3 className="sl-title wow fadeInRight" data-wow-delay="600ms" data-wow-duration="2000ms">Canadian Friends of IITM</h3>
                            <div style={{ color: "white", paddingBottom: "10px" }} className="sl-sub-title wow bounceInLeft" data-wow-delay="300ms" data-wow-duration="2000ms">Our mission is to raise endowment to support the growth of IITM and its students.</div>
                            <div className="sl-btn wow fadeInUp" data-wow-delay="900ms" data-wow-duration="2000ms">
                                {/* <a className="readon orange-btn main-home" href="https://joyofgiving.alumni.iitm.ac.in/ways-to-give">Explore Giving opportunities</a> */}
                                <Link className="readon orange-btn main-home" to="/givingopportunity" onClick={() => navigate()}>Explore Giving opportunities</Link>
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img style={{ height: '100vh', maxHeight: "500px" }}
                            className="d-block w-100"
                            src={img3}
                            alt="Second slide"
                        />

                        <Carousel.Caption>
                        <h3 className="sl-title wow fadeInRight" data-wow-delay="600ms" data-wow-duration="2000ms">Canadian Friends of IITM</h3>
                            <div style={{ color: "white", paddingBottom: "10px" }} className="sl-sub-title wow bounceInLeft" data-wow-delay="300ms" data-wow-duration="2000ms">Our mission is to raise endowment to support the growth of IITM and its students.</div>
                            <div className="sl-btn wow fadeInUp" data-wow-delay="900ms" data-wow-duration="2000ms">
                                {/* <a className="readon orange-btn main-home" href="https://joyofgiving.alumni.iitm.ac.in/ways-to-give">Explore Giving opportunities</a> */}
                                <Link className="readon orange-btn main-home" to="/givingopportunity" onClick={() => navigate()}>Explore Giving opportunities</Link>
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>
            </div>
        </>
    )
}

export default SliderNew
